export enum LaborRateType {
    Regular = 'REGULAR',
    OverTime = 'OVER TIME',
  }

  export enum SalaryRateType {
    Regular = 'RegularRate',
    OverTime = 'OvertimeRate',
  }